import React from "react";
import "react-tabs/style/react-tabs.css";
import { Button } from "react-bootstrap";
//import { Badge } from "react-bootstrap";
import { Card } from "react-bootstrap";
import { Breadcrumb } from "react-bootstrap";
import { withRouter } from 'react-router-dom';
import MUIDataTable from "mui-datatables";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { CardBody } from "reactstrap";
import EditIcon from '@material-ui/icons/Create';
import { IconButton } from '@material-ui/core';
import { Tooltip } from '@material-ui/core';
import SimpleReactValidator from 'simple-react-validator';
import axios from "axios";

var CryptoJS = require("crypto-js");
let key = process.env.REACT_APP_CRYPTO_KEY


class UserList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      userData: [""],
      adminPass: "",
      emailId: "",
      phoneNumber: "",
      statusUpdate: false,
      statusEdit: {},
      uusertype: "",
      editStatus: false, loader: false
    };
    this.validator = new SimpleReactValidator({ autoForceUpdate: this, className: 'text-danger' });

  }

  nextPath(path) {
    this.props.history.push({ pathname: path });
  }

  componentDidMount() {
    this.setState({ loader: true })
    axios.get(process.env.REACT_APP_NODE_ENV + "/api/users/fetchAll", {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
      }
    })
      .then(res => {
        let data = CryptoJS.AES.decrypt(res.data, key)
        let decData = JSON.parse(data.toString(CryptoJS.enc.Utf8))
        this.setState({ userData: decData, loader: false })
      }).catch(error => {
        console.log(error)
        this.setState({ userData: [], loader: false })
      })
  }

  editStatusHandler = value => {
    let value2 = ""
    this.state.userData.map(data => {
      if (data.id === value) { value2 = data }
    })
    console.log(value2)
    const doesToggle = this.state.editStatus;
    this.setState({ emailId: value2.userEmail, phoneNumber: value2.userPhoneNumber, uusertype: value2.userType,statusEdit: value2, editStatus: !doesToggle });
  };

  popUpCancel = () => {
    this.setState({ editStatus: false, statusUpdate: false });
  }

  save = () => {
    if (this.validator.allValid()) {
      this.setState({ editStatus: false })
      let postUserData = "";
      if (this.state.statusUpdate) {
        postUserData = {
          id: this.state.statusEdit.id, userEmail: this.state.emailId, userPhoneNumber: this.state.phoneNumber, userType: this.state.uusertype
        };
        postUserData = CryptoJS.AES.encrypt(JSON.stringify(postUserData), key).toString()
        fetch(process.env.REACT_APP_NODE_ENV + '/api/users/updateUser', {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
          },
          body: JSON.stringify({ data: postUserData })
        }).then((res) => res.json())
          .then((data) => this.componentDidMount())
          .catch((err) => console.log(err))
      }
      else {
        this.componentDidMount();
      }
    }
  }

  handleEditFormFields = (event) => {
    this.validator.showMessageFor(event.target.name)
    this.setState({ statusUpdate: true })
    switch (event.target.id) {
      case "emailId":
        this.setState({ emailId: event.target.value });
        break;
      case "phoneNumber":
        this.setState({ phoneNumber: event.target.value });
        break;
      case "uusertype":
          this.setState({ uusertype: event.target.value });
          break;
      default: break;
    }
  }

  render() {

    let dataArr = [];
    this.state.userData.map((data) => {
      if (data.userType === "Administrator" || data.userType === "Support User" || data.userType === "Super Admin" || data.userType === "CRE" || data.userType === "Logistics" || data.userType === "Project Engineer" || data.userType === "Marketing" || data.userType === "Accounts") {
        let variant = "";
        if (data.userType === "Customer") { variant = "success" }
        else if (data.userType === "Partner") { variant = "primary" }
        else { variant = "" }
        let mdData = {
          key: data.id,
          Name: data.userFirstName + ' ' + data.userLastName, MobileNumber: data.userPhoneNumber, UserType: data.userType, UserEmail: data.userEmail,
          actions: data.id
        };
        dataArr.push(mdData)
      }
      return null
    });


    const columns = [
      {
        name: "Name",
        label: "Name",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "MobileNumber",
        label: "Mobile Number",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "UserEmail",
        label: "Email Id",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "UserType",
        label: "User Type",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "actions",
        label: "Actions",
        options: {
          filter: false,
          sort: false,
          download: false,
          customBodyRender: (value, tableMeta, updateValue) => {
            return (
              <><Tooltip title="Edit Details"><IconButton onClick={() => this.editStatusHandler(value)} >
                <EditIcon /></IconButton></Tooltip> </>
            );
          }
        }
      }
    ];


    const options = {
      filterType: "textField",
      fixedHeader: true,
      sort: true,
      search: true,
      selectableRows: false,
      responsive: "scroll",
      rowsPerPage: 15,
      rowHove: true,
      selectableRowsHeader: true,
      expandableRows: false,
      expandableRowsOnClick: false,
      downloadOptions: {
        filename: 'User List.csv',
      },
      // onRowsDelete: (rowsDeleted) => {
      //   for (var key in rowsDeleted.data) {
      //     console.log(rowsDeleted.data[key].index)
      //     this.delete(dataArr[rowsDeleted.data[key].index].id)
      //   }
      // }
    };

    let statusEdit = (
      <><div className="col-lg-4">
        <label><b>E-mail</b></label>
        <input type="email" className="form-control" required name="Email Id" id="emailId" placeholder="E-mail" value={this.state.emailId} onChange={this.handleEditFormFields} />
        {
          this.validator.message('E-mail', this.state.emailId, 'required|email')
        }
      </div>
        <div style={{ paddingTop: "20px" }} className="col-lg-4">
          <label><b>Phone Number</b></label>
          <input className="form-control" required name="Phone Number" id="phoneNumber" placeholder="Phone Number" value={this.state.phoneNumber} onChange={this.handleEditFormFields} />
          {
            this.validator.message('Phone Number', this.state.phoneNumber, 'required|phone|max:10')
          }
        </div>
        <div style={{ paddingTop: "20px" }} className="col-lg-4">
          <label>User Type</label>
            <select name="uusertype" className="form-control" id="uusertype" value={this.state.uusertype} onChange={this.handleEditFormFields}>
              <option value="">Select User Type</option>
              <option value="Administrator">Administrator</option>
              <option value="Support User">Support User</option>
              <option value="CRE">CRE</option>
              <option value="Logistics">Logistics</option>
              <option value="Project Engineer">Project Engineer</option>
              <option value="Marketing">Marketing</option>
              <option value="Accounts">Accounts</option>
            </select>
        </div>
      </>)

    let userListTable = (<Card>
      <Card.Body>
        <div style={{ marginTop: "10px" }}>
          <Button className="float-right"
            variant="outline-success"
            style={{ marginTop: "10px", marginRight: "10px", width: "150px" }}
            onClick={() => this.nextPath("/user/user-create")
            }
          >
            Add User
                </Button>
          <MUIDataTable
            title={"User List"}
            data={dataArr}
            columns={columns}
            options={options} />
        </div>
      </Card.Body>
    </Card>);

    let editStatuss = null;
    if (this.state.editStatus) {
      editStatuss = (
        <Modal
          isOpen={true}
          style={{ width: "1200px", display: "block" }}
        >
          <Card style={{ width: "50rem" }}>
            <CardBody>
              <ModalHeader>Edit Details for - {this.state.statusEdit.userFirstName + " " + this.state.statusEdit.userLastName}</ModalHeader>
              <ModalBody>
                {statusEdit}
              </ModalBody>
              <ModalFooter>
                <Button variant="outline-primary" onClick={() => this.save()}>
                  Save
            </Button>&nbsp;&nbsp;&nbsp;
                <Button variant="outline-danger" onClick={() => this.popUpCancel()}> Cancel </Button>
              </ModalFooter>
            </CardBody>
          </Card>
        </Modal>
      );
    }

    return (
      <>
        <Breadcrumb>
          <Breadcrumb.Item active>User Details</Breadcrumb.Item>
        </Breadcrumb>
        <div>
          {editStatuss}
        </div>
        {userListTable}
      </>
    );
  }
}

export default withRouter(UserList);
